import { useMemo } from 'react';
import { useQuery } from '@supabase-cache-helpers/postgrest-swr';

import { supabase } from 'src/auth/context/supabase/lib';

// ----------------------------------------------------------------------

const baseColumns =
  'id,type,created_at,name,co2eq,workstation,workstation_percent,co2eq_per_employee,number_of_employees,number_of_employees_equipped,logo,parent,parent_name,is_parent,is_included_in_agent_tonnage,is_included_in_global_tonnage,can_access_ges,can_access_formations,can_access_diag_ref,can_access_engagement,max_sub_entities,max_users';
const defaultColumns = `${baseColumns},entities(${baseColumns})`;
export async function getEntity(entity_id) {
  return supabase.from('entities').select(defaultColumns).eq('id', entity_id);
}

export async function getMyEntities() {
  return supabase.from('entities').select(defaultColumns);
}

export function useGetMyEntities(columns = defaultColumns) {
  const { data, isLoading, error, isValidating } = useQuery(
    supabase.from('entities').select(columns) /* .is('parent', null) */
  );
  const memoizedValue = useMemo(
    () => ({
      entities: data || [],
      entitiesLoading: isLoading,
      entitiesError: error,
      entitiesValidating: isValidating,
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function useGetEntityById(entity_id, columns = defaultColumns) {
  const { data, isLoading, error, isValidating } = useQuery(
    !entity_id ? null : supabase.from('entities').select(columns).eq('id', entity_id)
  );

  const memoizedValue = useMemo(
    () => ({
      entity: (data ? data[0] : {}) || {},
      entityLoading: isLoading,
      entityError: error,
      entityValidating: isValidating,
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export function useGetMySubentities(parent_entity_id, columns = defaultColumns) {
  const { data, isLoading, error, isValidating } = useQuery(
    supabase.from('entities').select(columns).eq('parent', parent_entity_id)
  );
  const memoizedValue = useMemo(
    () => ({
      entities: data || [],
      entitiesLoading: isLoading,
      entitiesError: error,
      entitiesValidating: isValidating,
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export async function getMySubEntities(parent_entity_id, columns = defaultColumns) {
  return supabase.from('entities').select(defaultColumns).eq('parent', parent_entity_id);
}
